import { useState } from 'react';
import { DropDownOption } from '../../../components/LHFilter';

export interface Filters {
  date: string;
  standupType: string;
  status: string;
  createdBy: string;
  modifiedBy: string;
}

export interface UseStandUpCardsFiltersReturn {
  filters: Filters;
  setFilters: (filters: Filters) => void;
  handleFilterChange: (key: string, value: DropDownOption | DropDownOption[] | null) => void;
  handleResetFilters: () => void;
}

export const useStandUpCardsFilters = (): UseStandUpCardsFiltersReturn => {
  const [filters, setFilters] = useState<Filters>({
    date: '',
    standupType: '',
    status: '',
    createdBy: '',
    modifiedBy: '',
  });

  // Handle filter change - matching SparcWalk implementation
  const handleFilterChange = (key: string, value: DropDownOption | DropDownOption[] | null) => {
    // Extract the id from the selected option
    const selectedId = value && !Array.isArray(value) ? value.id.toString() : '';
    
    setFilters(prev => ({
      ...prev,
      [key]: selectedId,
    }));
  };

  // Reset all filters - matching SparcWalk implementation
  const handleResetFilters = () => {
    setFilters({
      date: '',
      standupType: '',
      status: '',
      createdBy: '',
      modifiedBy: '',
    });
    // Filters useEffect will trigger and show originalItems
  };

  return {
    filters,
    setFilters,
    handleFilterChange,
    handleResetFilters,
  };
};
